"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractiveMechanicEvaluator = void 0;
class InteractiveMechanicEvaluator {
    async evaluate(submission, activity) {
        const structured = (submission.structuredData || {});
        const mechanic = activity.mechanic || 'interactive';
        // Check explicit score or isCorrect flag provided in structuredData
        let score = 100;
        let isCorrect = true;
        if (typeof structured.score === 'number') {
            score = Math.max(0, Math.min(100, Math.round(structured.score)));
            isCorrect = score >= 80;
        }
        else if (typeof structured.isCorrect === 'boolean') {
            isCorrect = structured.isCorrect;
            score = isCorrect ? 100 : 50;
        }
        else if (typeof structured.completed === 'boolean') {
            isCorrect = structured.completed;
            score = isCorrect ? 100 : 0;
        }
        const feedback = structured.feedback
            ? String(structured.feedback)
            : isCorrect
                ? 'Super work! You successfully solved the challenge.'
                : 'Good effort! Review your solution and try again.';
        const label = mechanic.split('_').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
        return {
            score,
            maxScore: 100,
            isCorrect,
            feedback,
            breakdown: [
                {
                    name: `${label} Accuracy`,
                    score,
                    maxScore: 100,
                    feedback,
                },
            ],
            skills: [
                {
                    key: `${mechanic}:${String(activity.id || 'activity').slice(0, 8)}`,
                    label: `${label} Mastery`,
                },
            ],
            label: `${label} Result`,
        };
    }
}
exports.InteractiveMechanicEvaluator = InteractiveMechanicEvaluator;
